window.addEventListener('load', function () {
    const inputFields = document.getElementsByTagName('input');

    for (let i = 0; i < inputFields.length; i++) {
        inputFields[i].setAttribute('autocomplete', 'off');
    }
});